import { Box, Text } from "@modernatx/ui-kit-react";
import React from "react";

const NoteCard: React.FC<{ notes: string[] }> = ({ notes }) => (
  <Box
    sx={{
      borderRadius: "radius-2",
      borderColor: "stroke-neutral-tertiary",
      backgroundColor: "color-system-yellow-50",
      overflow: "hidden",
      boxShadow: "shadow-200"
    }}
  >
    <Box
      sx={{
        backgroundColor: "color-system-yellow-200",
        gap: "spacing-4",
        px: "spacing-6",
        py: "spacing-4"
      }}
    >
      <Text weight="bold">Note</Text>
    </Box>
    {notes.map((note, index) => (
      <Box
        key={`note-${index}`}
        sx={{
          gap: "spacing-4",
          px: "spacing-6",
          py: "spacing-4"
        }}
      >
        <Text>{note}</Text>
      </Box>
    ))}
  </Box>
);

export default NoteCard;
